/**
 * Split the array into smaller chunks.
 *
 * @param array - The source array to split into chunks
 * @param chunkSize - The desired length of the chumks
 * @returns An array of arrays
 */
export function chunkArray<T>(array: ReadonlyArray<T>, chunkSize: number): T[][] {
    return Array.from({ length: Math.ceil(array.length / chunkSize) }, (_, index) =>
        array.slice(index * chunkSize, (index + 1) * chunkSize),
    );
}
